export default "__VITE_ASSET__Cy8ErOZf__"